import { colorsByName } from "./colors.js";

const data = {
  "кручёная": {
    "22x32+12": { "чёрный": 18.5 },
    "22x25+12": { "белый": 16.5, "бурый": 14.5 },
    "24x32+11": { "белый": 14.0, "бурый": 13.0, "чёрный": 18.5 },
    "32x37+18": { "белый": 16.5, "бурый": 15.5 },
    "35x45+15": { "белый": 17.5, "бурый": 16.5 },
  },
  "плоская": {
    "25x32+10": {
      "белый": 13.0, "бурый": 12.7, "зелёный": 17.5,
      "красный": 17.5, "синий": 17.5, "тёмно-синий": 17.5, "чёрный": 17.5,
    },
    "32x37+20": { "белый": 15.0, "бурый": 13.5 },
    "32x45+15": { "белый": 13.5, "бурый": 12.0 },
    "35x45+15": { "белый": 16.5, "бурый": 14.5 },
  },
};

export function packPrice(handle, size, color) {
  return data?.[handle]?.[size]?.[color];
}

export function handleScale() {
  return Object.keys(data);
}

export function sizeScale(handle) {
  return Object.keys(data[handle] ?? {});
}

export function defaultSize(handle) {
  return sizeScale(handle)[0];
}

export function colorsScale(handle, size) {
  const names = Object.keys(data?.[handle]?.[size] ?? {});
  return colorsByName(names);
}

export function defaultColor(handle, size, prevColorName) {
  const scale = colorsScale(handle, size);
  return scale.find((c) => c.name === prevColorName) || scale[0];
}
